import _ from 'lodash'

export function formatUser(response) {
    if (!response) return null

    const auth = {
        id: _.get(response, 'user_id', _.get(response, 'id_user')),
        name: _.get(response, 'Account'),
        username: _.get(response, 'Account'),
        email: _.get(response, 'Email'),
        currency: 'EUR',
        balance: parseFloat(_.get(response, 'Money', 0)),
        firstname: _.get(response, 'FirstN'),
        lastname: _.get(response, 'Name'),
        lastname2: _.get(response, 'Name2'),
        status_cnj: _.get(response, 'status_cnj'),
        ask_for_terms: _.get(response, 'askforterms'),
        ask_for_privacy: _.get(response, 'askforprivacy'),
        ask_for_cookie: _.get(response, 'askforcookie'),
        accept_promo_via_email: _.get(response, 'accept_promo_via_email'),
        accept_promo_via_sms: _.get(response, 'accept_promo_via_sms'),
        accepts_promo_popups: _.get(response, 'accepts_promo_popups'),
        accepts_phone_calls: _.get(response, 'accepts_phone_calls'),
        require_verify: _.get(response, 'require_verify'),
        combo_boost_optin: _.get(response, 'combo_boost_optin'),
        opted_in_promotions: _.get(response, 'opted_in_promotions'),
        favorite_sports: _.get(response, 'favorite_sports'),
        favorite_competitions: _.get(response, 'favorite_competitions'),
        is_club_bet_member: _.get(response, 'is_clubet_member'),
        cashier_mode: _.get(response, 'cashier_mode'),
    }

    if (_.has(auth, 'username')) {
        return auth
    }

    return null
}